export type OperatorName =
    | 'like'
    | 'not-like'
    | 'eq'
    | 'ne'
    | 'not-null'
    | 'null'
    | 'yesterday'
    | 'today'
    | 'tomorrow'
    | 'last-seven-days'
    | 'next-seven-days'
    | 'last-week'
    | 'this-week'
    | 'last-month'
    | 'this-month'
    | 'on'
    | 'on-or-before'
    | 'on-or-after'
    | 'last-year'
    | 'this-year'
    | 'last-x-days'
    | 'next-x-days'
    | 'last-x-months'
    | 'next-x-months'
    | 'gt'
    | 'ge'
    | 'le'
    | 'lt'
    | 'contain-values'
    | 'not-contain-values'
    | 'begins-with'
    | 'not-begin-with'
    | 'ends-with'
    | 'not-end-with'
    | 'in'
    | 'not-in';

export interface IOperator {
    Name: OperatorName;
    Value: ComponentFramework.PropertyHelper.DataSetApi.Types.ConditionOperator;
}
export class Operators {
    //@ts-ignore - some operators are not part of PCF typings
    private static _operatorMap: Map<string, ComponentFramework.PropertyHelper.DataSetApi.Types.ConditionOperator> = new Map([
        ['like', 6],
        ['not-like', 7],
        ['eq', 0],
        ['ne', 1],
        ['not-null', 13],
        ['null', 12],
        ['yesterday', 14],
        ['today', 15],
        ['tomorrow', 16],
        ['last-seven-days', 17],
        ['next-seven-days', 18],
        ['last-week', 19],
        ['this-week', 20],
        ['last-month', 22],
        ['this-month', 23],
        ['on', 25],
        ['on-or-before', 26],
        ['on-or-after', 27],
        ['last-year', 28],
        ['this-year', 29],
        ['last-x-days', 33],
        ['next-x-days', 34],
        ['last-x-months', 37],
        ['next-x-months', 38],
        ['gt', 2],
        ['ge', 4],
        ['le', 5],
        ['lt', 3],
        ['contain-values', 87],
        ['not-contain-values', 88],
        ['begins-with', 54],
        ['not-begin-with', 55],
        ['ends-with', 56],
        ['not-end-with', 57],
        ['in', 8],
        ['not-in', 9]
    ]);

    static get Like(): IOperator {
        return { Name: 'like', Value: 6 };
    }

    static get NotLike(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'not-like', Value: 7 };
    }

    static get Equal(): IOperator {
        return { Name: 'eq', Value: 0 };
    }

    static get DoesNotEqual(): IOperator {
        return { Name: 'ne', Value: 1 };
    }

    static get NotNull(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'not-null', Value: 13 };
    }

    static get ContainsData(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'not-null', Value: 13 };
    }

    static get DoesNotContainData(): IOperator {
        return { Name: 'null', Value: 12 };
    }

    static get Yesterday(): IOperator {
        return { Name: 'yesterday', Value: 14 };
    }

    static get Today(): IOperator {
        return { Name: 'today', Value: 15 };
    }

    static get Tomorrow(): IOperator {
        return { Name: 'tomorrow', Value: 16 };
    }

    static get Last7Days(): IOperator {
        return { Name: 'last-seven-days', Value: 17 };
    }

    static get Next7Days(): IOperator {
        return { Name: 'next-seven-days', Value: 18 };
    }

    static get LastWeek(): IOperator {
        return { Name: 'last-week', Value: 19 };
    }

    static get ThisWeek(): IOperator {
        return { Name: 'this-week', Value: 20 };
    }

    static get LastMonth(): IOperator {
        return { Name: 'last-month', Value: 22 };
    }

    static get ThisMonth(): IOperator {
        return { Name: 'this-month', Value: 23 };
    }

    static get On(): IOperator {
        return { Name: 'on', Value: 25 };
    }

    static get OnOrBefore(): IOperator {
        return { Name: 'on-or-before', Value: 26 };
    }

    static get OnOrAfter(): IOperator {
        return { Name: 'on-or-after', Value: 27 };
    }

    static get LastYear(): IOperator {
        return { Name: 'last-year', Value: 28 };
    }

    static get ThisYear(): IOperator {
        return { Name: 'this-year', Value: 29 };
    }

    static get LastXDays(): IOperator {
        return { Name: 'last-x-days', Value: 33 };
    }

    static get NextXDays(): IOperator {
        return { Name: 'next-x-days', Value: 34 };
    }

    static get LastXMonths(): IOperator {
        return { Name: 'last-x-months', Value: 37 };
    }

    static get NextXMonths(): IOperator {
        return { Name: 'next-x-months', Value: 38 };
    }

    static get GreaterThan(): IOperator {
        return { Name: 'gt', Value: 2 };
    }

    static get GreaterThanOrEqual(): IOperator {
        return { Name: 'ge', Value: 4 };
    }

    static get LessThanOrEqual(): IOperator {
        return { Name: 'le', Value: 5 };
    }

    static get LessThan(): IOperator {
        return { Name: 'lt', Value: 3 };
    }

    static get ContainValues(): IOperator {
        return { Name: 'contain-values', Value: 87 };
    }

    static get DoesNotContainValues(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'not-contain-values', Value: 88 };
    }

    static get BeginsWith(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'begins-with', Value: 54 };
    }

    static get DoesNotBeginWith(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'not-begin-with', Value: 55 };
    }

    static get EndsWith(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'ends-with', Value: 56 };
    }

    static get DoesNotEndWith(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'not-end-with', Value: 57 };
    }

    static get In(): IOperator {
        return { Name: 'in', Value: 8 };
    }

    static get NotIn(): IOperator {
        //@ts-ignore - not part of PCF types
        return { Name: 'not-in', Value: 9 };
    }

    static GetValueFromName(name: OperatorName): ComponentFramework.PropertyHelper.DataSetApi.Types.ConditionOperator {
        const Value = this._operatorMap.get(name);
        if (Value === undefined) {
            throw new Error(`Invalid operator ${Value}`);
        }
        return Value;
    }
    static GetNameFromValue(value: ComponentFramework.PropertyHelper.DataSetApi.Types.ConditionOperator): string {
        let name;
        for (const [key, val] of this._operatorMap.entries()) {
            if (val === value) {
                name = key;
            }
        }
        if (!name) {
            throw new Error('Invalid operator Value!');
        }
        return name;
    }
}